import { Component } from 'preact';
import { NavigationSubLinks } from './navigationSubLink';
import { NavigationBase } from './navigationBase';

class NavigationLink extends Component {
  render(props, state) {

    const open = props.openedMenuItems.items.indexOf(props.item.Name) >= 0;
    const active = props.activatedPath.item === props.item.Name

    const linkAction = e => {
      if(!!props.item.SubItems && props.item.SubItems.length > 0) {
        props.toggleMenuItem(props.item.Name)
      } else {
        props.setPathActive(props.item.Name)
        props.navigationCallback(props.item.Path)
      }
    }

    return (
      <div>
      {!props.item.External &&
        <div>
          <div onClick={linkAction} className={"navigation-link " + (active? "active " : " ") + (open? "open" : "closed")}>
            <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={!!props.item.SubItems && props.item.SubItems.length > 0} open={open} item={props.item}></NavigationBase>
          </div>
          { open && !!props.item.SubItems &&
            <NavigationSubLinks
              activatedPath={props.activatedPath}
              openedMenuItems={props.openedMenuItems}
              removeMenuItem={props.removeMenuItem}
              item={props.item}
              navigationCallback={props.navigationCallback}
              setPathActive={props.setPathActive}
              toggleMenuSubItem={props.toggleMenuSubItem}
              account={props.account}>
            </NavigationSubLinks>
          }
        </div>
      }
      {props.item.External &&
        <a href={props.item.Path} className={"navigation-link External-link"}>
          <NavigationBase removeMenuItem={props.removeMenuItem} dropdown={false} open={false} item={props.item}></NavigationBase>
        </a>
      }
      </div>
    );
  }
}

export {NavigationLink};



// WEBPACK FOOTER //
// ./components/sidebar/navigationlink.js